import React, { Component } from 'react';
import '../assets/boxicons-2.0.7/css/boxicons.min.css';
import { cx } from '@emotion/css';
import * as styles from './questionWithTextFeild.style';
import QuizIndicator from './QuizIndicator';
import Meanings from './Meanings';
import withQuizPic from './hoc/withQuizPic';
import * as styles2 from './newQuestionBox.style';

class TexttoSpeechwithTextfield extends Component {
  state = {
    showmeaning: false,
    meaning: '',
  };

  constructor(props) {

    ////console.log("Calling TexttoSpeechwithTextfield constructor")
    super(props);


    this.state = {
      value: this.props.selectedanswer != '' ? this.props.selectedanswer : '',
      quizPic: '',
    };

    this.textInput = React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.handleKeypress = this.handleKeypress.bind(this);
    this.focus = this.focus.bind(this);
    this.closemeaningwindow = this.closemeaningwindow.bind(this);

    var utterance = new window.SpeechSynthesisUtterance();
    var word = this.props.question.replace('Spell', '').trim()

    utterance.text = word
    if (this.props.subcategory == 'Spanish') {
      utterance.lang = 'es-US';
    }
    else {
      utterance.lang = 'en-US';
    }


    //utterance.rate = 0.9
    if (this.props.audio != '' && this.props.audio != undefined) {

      this.firstimecall()
    }
    else {
      window.speechSynthesis.speak(utterance);
    }


    // const audio = new Audio(
    //   "https://api.dictionaryapi.dev/media/pronunciations/en/abnormal-us.mp3"
    // );
    // audio.play()



  }

  focus() {
    this.textInput.current.focus();
  }

  closemeaningwindow() {
    // //console.log("Seeting showmeaning to false")
    this.setState({ showmeaning: false });
    this.focus();
  }

  uttertext_GB = () => {
    var utterance = new window.SpeechSynthesisUtterance();
    var word = this.props.word_to_pronounce

    utterance.text = word


    if (this.props.subcategory == 'Spanish') {
      utterance.lang = 'es-US';
    }
    else {
      utterance.lang = 'en-GB';
    }

    window.speechSynthesis.speak(utterance);
    this.focus();
  };

  playexample = () => {
    var word = this.props.question.replace('Spell', '').trim()

    //var audiofile = 'https://api.dictionaryapi.dev/media/pronunciations/en/' + word + "-us.mp3"

    // var audiofile = 'https://ssl.gstatic.com/dictionary/static/sounds/oxford/' + word.toLowerCase() + "--_us_1.mp3"

    var audiofile = this.props.example

    // Older word lists stores example as plain text meant to be read aloud
    // instead of an audio file URL; fall back to speech synthesis for those.
    if (!/^https?:\/\//i.test((audiofile || '').trim())) {
      this.speakexample();
      return;
    }

    const audio = new Audio(audiofile);
    const playPromise = audio.play();

    if (playPromise !== undefined) {
      playPromise
        .then(_ => {
          // Automatic playback started!
          // Show playing UI.

        })
        .catch(error => {
          // Auto-play was prevented
          // Show paused UI.
          // console.log("Unable to get audio from marriam");
          // var audiofile = 'https://api.dictionaryapi.dev/media/pronunciations/en/' + word.toLowerCase() + "-us.mp3"
          // const audio = new Audio(audiofile);
          // const playPromise = audio.play();

          // if (playPromise !== undefined) {
          //   playPromise
          //     .then(_ => {
          //       // Automatic playback started!
          //       // Show playing UI.

          //     })
          //     .catch(error => {

          //       //console.log("Unable to get audio from api.dictionaryapi.dev");

          //     });

          // }
        });


    }


    // audio.play()



    // var audiofile = 'https://api.dictionaryapi.dev/media/pronunciations/en/' + word.toLowerCase() + "-us.mp3"





    // const audio = new Audio(audiofile);

    // audio.play()



    this.focus()

  };





  getMp3fromdictionary = () => {
    var word = this.props.question.replace('Spell', '').trim()

    //var audiofile = 'https://api.dictionaryapi.dev/media/pronunciations/en/' + word + "-us.mp3"

    // var audiofile = 'https://ssl.gstatic.com/dictionary/static/sounds/oxford/' + word.toLowerCase() + "--_us_1.mp3"

    var audiofile = this.props.audio

    const audio = new Audio(audiofile);
    const playPromise = audio.play();

    if (playPromise !== undefined) {
      playPromise
        .then(_ => {
          // Automatic playback started!
          // Show playing UI.

        })
        .catch(error => {
          // Auto-play was prevented
          // Show paused UI.
          // console.log("Unable to get audio from marriam");
          // var audiofile = 'https://api.dictionaryapi.dev/media/pronunciations/en/' + word.toLowerCase() + "-us.mp3"
          // const audio = new Audio(audiofile);
          // const playPromise = audio.play();

          // if (playPromise !== undefined) {
          //   playPromise
          //     .then(_ => {
          //       // Automatic playback started!
          //       // Show playing UI.

          //     })
          //     .catch(error => {

          //       //console.log("Unable to get audio from api.dictionaryapi.dev");

          //     });

          // }
        });


    }


    // audio.play()



    // var audiofile = 'https://api.dictionaryapi.dev/media/pronunciations/en/' + word.toLowerCase() + "-us.mp3"





    // const audio = new Audio(audiofile);

    // audio.play()


    this.focus()


  };


  firstimecall = () => {
    var word = this.props.question.replace('Spell', '').trim()

    //var audiofile = 'https://api.dictionaryapi.dev/media/pronunciations/en/' + word + "-us.mp3"

    // var audiofile = 'https://ssl.gstatic.com/dictionary/static/sounds/oxford/' + word.toLowerCase() + "--_us_1.mp3"

    var audiofile = this.props.audio

    const audio = new Audio(audiofile);
    const playPromise = audio.play();

    if (playPromise !== undefined) {
      playPromise
        .then(_ => {
          // Automatic playback started!
          // Show playing UI.

        })
        .catch(error => {
          // Auto-play was prevented
          // Show paused UI.
          // console.log("Unable to get audio from marriam");
          // var audiofile = 'https://api.dictionaryapi.dev/media/pronunciations/en/' + word.toLowerCase() + "-us.mp3"
          // const audio = new Audio(audiofile);
          // const playPromise = audio.play();

          // if (playPromise !== undefined) {
          //   playPromise
          //     .then(_ => {
          //       // Automatic playback started!
          //       // Show playing UI.

          //     })
          //     .catch(error => {

          //       //console.log("Unable to get audio from api.dictionaryapi.dev");

          //     });

          // }
        });


    }


    // audio.play()



    // var audiofile = 'https://api.dictionaryapi.dev/media/pronunciations/en/' + word.toLowerCase() + "-us.mp3"





    // const audio = new Audio(audiofile);

    // audio.play()





  };





  uttertext_US = () => {
    var utterance = new window.SpeechSynthesisUtterance();
    var word = this.props.word_to_pronounce;
    utterance.text = word;

    if (this.props.subcategory == 'Spanish') {
      utterance.lang = 'es-ES';
    }
    else {
      utterance.lang = 'en-US';
    }

    window.speechSynthesis.speak(utterance);
    this.focus();
  };



  speakexample = () => {
    var utterance = new window.SpeechSynthesisUtterance();
    utterance.text = this.props.example;

    if (this.props.subcategory == 'Spanish') {
      utterance.lang = 'es-ES';
    }
    else {
      utterance.lang = 'en-GB';
    }

    utterance.rate = 0.9


    window.speechSynthesis.speak(utterance);
    this.focus();
  };



  tellMeaning = (word) => {

    //console.log(word)
    // if (this.props.meaning === undefined || this.props.meaning === null) {
    //   this.setState({ meaning: "" });
    //   ////console.log("set meaing as  "+this.state.meaning)
    //   this.setState({ showmeaning: true });


    //   // // var utterance = new window.SpeechSynthesisUtterance();

    //   // // utterance.pitch = 0.6;
    //   // // utterance.rate = 0.9;
    //   // // utterance.lang = 'en-GB';

    //   // ////console.log(requestOptions)

    //   // // fetch(`https://api.dictionaryapi.dev/api/v2/entries/en/`+word)
    //   // // .then(response => response.json())
    //   // // .then(data =>  data[0]['meanings'][0]['definitions'][0]['definition'])
    //   // // .then(meaning => {utterance.text = "Meaning of " + word + " is " + meaning ; window.speechSynthesis.speak(utterance) });

    //   fetch(`https://api.dictionaryapi.dev/api/v2/entries/en/` + word)
    //     .then((response) => {
    //       if (response.ok) {
    //         return response.json();
    //       } else if (response.status === 404) {
    //         this.setState({ meaning: 'Not Available' });
    //         this.setState({ showmeaning: true });
    //       } else {
    //         this.setState({ meaning: 'Not Available' });
    //         this.setState({ showmeaning: true });
    //       }
    //     })
    //     .then((data) => {
    //       let meaningdata =
    //         data[0]['meanings'][0]['definitions'][0]['definition'];
    //       let example =
    //         data[0]['meanings'][0]['definitions'][0]['example'];

    //       if (meaningdata.toLowerCase().includes(word.toLowerCase().slice(0, (word.length - 3)))) {
    //         meaningdata = 'Not Available'
    //       }


    //       // utterance.text = 'Meaning of ' + word + ' is ' + meaningdata;
    //       this.setState({ meaning: meaningdata });
    //       ////console.log("set meaing as  "+this.state.meaning)
    //       this.setState({ showmeaning: true });
    //     })
    //     .catch((error) => {
    //       this.setState({ meaning: "Not Available" });
    //       ////console.log("set meaing as  "+this.state.meaning)
    //       this.setState({ showmeaning: true });

    //       //  utterance.text = 'Not Available';
    //     });
    // }
    // else {

    //   this.setState({ meaning: this.props.meaning });
    //   ////console.log("set meaing as  "+this.state.meaning)
    //   this.setState({ showmeaning: true });
    // }
    this.setState({ meaning: this.props.meaning });
    this.setState({ showmeaning: true });
  };

  handleKeypress(e) {

    //it triggers by pressing the enter key
    if (e.key == "Enter") {
      this.props.nextbutton();
      // console.log("Calling nExt")
    }
  }

  handleChange(event) {

    this.setState({ value: event.target.value });
    this.props.selected(event.target.value, '1');
  }

  // selectedanswer = (answer, id) => {
  //   //////console.log(answer)
  //   // ////console.log(id)
  //   console.log("Calling selecteanswert")
  //   this.props.selected(answer, id);
  //   var utterance = new window.SpeechSynthesisUtterance();
  //   utterance.text = 'hello';
  //   utterance.lang = 'en-US';
  //   window.speechSynthesis.speak(utterance);
  // };

  componentDidMount() {
    this.setState({
      quizPic: this.props.getRandomImage(this.props.questionnumber),
    });
  }

  render() {
    return (
      <div>
        <h2 className={cx(styles.title)}>
          <span>Q{this.props.questionnumber}/</span>
          {this.props.questionCount}
        </h2>
        {this.props.specific_category.includes("Spanish") && (



          <div className={cx(styles.questions)}>{this.props.question}</div>
        )}


        <img className={cx(styles.img)} src={this.state.quizPic} alt="" />
        <div className={cx(styles.meanings)}>Meaning: {this.props.meaning}</div>
        <QuizIndicator
          questionCount={this.props.questionCount}
          questionnumber={this.props.questionnumber}
        />
        {this.state.showmeaning && (
          <Meanings
            closewindow={this.closemeaningwindow}
            meaning={this.state.meaning}
          />
        )}

        <div>
          <div className={cx(styles.iconGroup)}>
            {this.props.audio != "" && (
              <img
                src="../assets/redphone.png"
                alt=""
                className="card1-img-top"
                onClick={this.getMp3fromdictionary}

              />
            )
            }
            <img
              src="../assets/bluephone.png"
              alt=""
              className="card1-img-top"
              onClick={this.uttertext_GB}
            />

            {this.props.category == "Spelling Bowl" && (
              <img
                src="../assets/redphone.png"
                alt=""
                className="card1-img-top"
                onClick={this.uttertext_US}
              />
            )
            }

            {this.props.category == "Spelling Bowl" && this.props.example != "Sorry, No Examples Available" && (
              <img
                src="../assets/bulb.png"
                alt=""
                className="card1-img-top"
                // onClick={() =>
                //   this.speakexample(
                //     this.props.question.replace('Spell', '').trim()
                //   )
                // }
                onClick={this.playexample}
              />
            )
            }
          </div>

          <div className={cx(styles.answers)}>
            <div className="s-title">Type Answer below</div>
            <div>
              <input
                id={this.props.id}
                type="text"
                value={this.state.value}
                onChange={this.handleChange}
                placeholder="Enter answer here ..."
                spellCheck="false"
                autoComplete="off"
                onKeyDown={this.handleKeypress}
                autoFocus={true}
                ref={this.textInput}
                className={cx(styles.input)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withQuizPic(TexttoSpeechwithTextfield);

